import { useEffect, useState } from 'react';

// Returns the number of pixels the floating UI should be offset upward
// so it never overlaps the footer. 0 when the footer is below the viewport.
export default function useFooterOffset() {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const footer = document.querySelector('footer');
    if (!footer) return;

    let ticking = false;
    const update = () => {
      ticking = false;
      const rect = footer.getBoundingClientRect();
      const overlap = window.innerHeight - rect.top;
      setOffset(overlap > 0 ? overlap : 0);
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return offset;
}
